import {Injectable} from "@angular/core";
import {BaseDataService, HttpResponsesHandlersFactory} from "@bbwt/modules/data-service";
import {HttpClient} from "@angular/common/http";
import {IFormDataVariable} from "@main/formio/formio.models";

@Injectable()
export class FormioVariableProviderService extends BaseDataService {
    public readonly url = "api/formio-variable";

    constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
        super(http, handlersFactory);
    }

    getFormDataVariables(): Promise<IFormDataVariable[]> {
        return this.httpGet<IFormDataVariable[]>("data-variables")
    }
}